export const ALL = 'all';
export const ALL_MODELS = 'allModels';
export const ALL_SERIES = 'allSeries';
export const ALL_LINES = 'allLines';
